import React from 'react';
import PropTypes from 'prop-types';
import { ProminentLabel } from 'web-ui-components/lib/typography/labels';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import HomepageBL from '../homepage/HomepageBL';

const AccountPickerSelectedAccount = ({
  onShowAccountPicker,
  mainLabelText,
  buttonText,
  account,
}) => {
  const acc = HomepageBL.getAccountDisplayNumber(account);
  return (
    <div className="web-ui-components">
      <ProminentLabel>{mainLabelText}</ProminentLabel>
      <div className="accountpicker__selectedAccount">
        <div className="accountpicker__selectedAccount__details">
          <div>{account.accountName}</div>
          <div className="accountpicker__selectedAccount__details__displayName">
            {account.displayName}
          </div>
          <div>
            {account.type === 'credit-card'
              ? `$(acc)`
              : `${acc.sortcode} ${acc.accountNumber}`}
          </div>
        </div>
        <Button display="secondary" onClick={onShowAccountPicker}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

AccountPickerSelectedAccount.propTypes = {
  onShowAccountPicker: PropTypes.func.isRequired,
  mainLabelText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  account: PropTypes.object.isRequired,
};

export default AccountPickerSelectedAccount;
